import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Eyebrow, SerifH } from "./shared";

const TILES = [
  { src: "/yaba_carousel_01.jpg", cap: "Bold strokes.  Timeless silhouette." },
  { src: "/yaba_carousel_02.jpg", cap: "Where art meets tradition." },
  { src: "/yaba_carousel_04.jpg", cap: "Serenity in every step." },
];

export function Reels() {
  return (
    <section id="reels" data-testid="reels" className="bg-[#0C111C] text-[#F4EDE2]">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-20 py-20 md:py-28">
        <div className="flex items-end justify-between mb-10">
          <div>
            <Eyebrow>@yaba.menswear</Eyebrow>
            <SerifH className="mt-3 text-[#F4EDE2]" size="clamp(28px, 3.4vw, 48px)">
              In motion.
            </SerifH>
          </div>
          <a
            href="#"
            className="hidden md:inline-flex items-center gap-2 text-sm underline decoration-[#C8A96A] underline-offset-4 hover:text-[#C8A96A]"
            style={{ fontFamily: "Inter, sans-serif" }}
          >
            Follow us <ArrowRight size={14} />
          </a>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {TILES.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="group relative aspect-[4/5] overflow-hidden rounded-md bg-[#111013]"
            >
              <img
                src={t.src}
                alt={t.cap}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-[1.04]"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
